import { MESSAGE_TYPE } from '../../constants/MessageTypes';
import AbstractMessageModel from './AbstractMessageModel';

export default class TicketPartMessageModel extends AbstractMessageModel {
  constructor({ ticket, ...args } = {}) {
    super({
      messageType: MESSAGE_TYPE.TICKET_PART,
      ...args,
    });

    this.ticket_id = ticket.id;
    this.amount = ticket.amount;
    this.article_number = ticket.articleNumber;
    this.description = ticket.description;
    this.kbn = ticket.kbn;
    this.manufacturer = ticket.manufacturer;
    this.url = ticket.url;
    this.external_jira_key = ticket.externalJiraKey;
  }
}
